import React, { Component } from 'react';
import dayjs from 'dayjs';
import services from '@C/Reports/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'date',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Opening cash balance',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.opening_balance)}</>;
    },
  },
  {
    name: 'Cash received from duties',
    key: 'cash_received_from_duties',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.shift_name} - {formatCurrency(item.amount)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Office Income',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.all_incomes)}</>;
    },
  },
  {
    name: 'Office Expenses',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.all_expenses)}</>;
    },
  },
  {
    name: 'Total cash collected for the day',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.total_cash_received)}</>;
    },
  },
  {
    name: 'Bank deposit',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.cash_deposit)}</>;
    },
  },
  {
    name: 'Closing cash balance',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.closing_balance)}</>;
    },
  },
];

class CashBookShiftWiseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cashbookList: [],
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getCashbookShiftwiseReport();
  }

  getCashbookShiftwiseReport = () => {
    this.setState({ loading: true });
    services
      .getCashbookShiftwiseReport(this.state)
      .then((res) => {
        this.setState({
          cashbookList: res.data.data.results,
          count: res.data.data.count,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value }, () =>
        this.getCashbookShiftwiseReport(),
      );
    } else {
      this.setState({ [name]: value });
    }
  };

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getCashbookShiftwiseReport();
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, () => {
      this.getCashbookShiftwiseReport();
    });
  };

  resetFilter = () => {
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        limit: 20,
        offset: 1,
      },
      () => {
        this.getCashbookShiftwiseReport();
      },
    );
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getCashbookShiftwiseReport();
    });
  };

  render() {
    const { cashbookList } = this.state;
    const exportOptions = {
      fileName: ` Cash Book Shift Wise- ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Cash Book Shift Wise Report',
      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
      reportTotal: `Closing balance -  ${
        cashbookList[0]?.closing_balance.toFixed(2) || 0
      }`,
      reportQuantity: '',
      reportSales: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
      reportTesting: '',
      reportBowser: '',
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
    };
    return (
      <section className="widget list-table full-width inverted">
        <header>
          <div className="stock-info-headers">
            <h3>Cashbook Shiftwise Report ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Closing balance: </span>
                  <span>
                    {formatCurrency(cashbookList[0]?.closing_balance || 0)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={cashbookList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: ` Cash Book Shift Wise- ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Cash Book Shift Wise Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Closing balance -  ${
                        cashbookList[0]?.closing_balance.toFixed(2) || 0
                      }`,
                      reportQuantity: '',
                      reportSales: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { CashBookShiftWiseReport };
